export default {
  currentTimer: state => state.currentTimer,
  timerSettings: state => state.timerSettings,
  settingsActive: state => state.settingsActive,
};
